export function validarCedula(cedula: string) {
  const arrCoefs = [2, 9, 8, 7, 6, 3, 4, 1];
  let suma = 0;
  const largocedula = cedula.length - 1;
  const difCoef = arrCoefs.length - cedula.length;
  let i;
  for (i = 0; i < largocedula; i++) {
    const digito = parseInt(cedula.substring(i, i + 1));
    const coef = arrCoefs[i + difCoef];
    suma += coef * digito;
  }
  const verificador = parseInt(cedula.substring(i, i + 1));
  return (suma + verificador) % 10 == 0;
}
